webpackJsonp([0],{

/***/ "+zkC":
/*!***********************************************!*\
  !*** ./src/containers/ModelConditionsStep.js ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(/*! react */ "GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(/*! react-redux */ "RH2O");

var _configuration = __webpack_require__(/*! ../actions/configuration */ "gcEp");

var _redux = __webpack_require__(/*! redux */ "2KeS");

var _reactTooltip = __webpack_require__(/*! react-tooltip */ "Hh2+");

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModelConditionsStep = function (_Component) {
    _inherits(ModelConditionsStep, _Component);

    function ModelConditionsStep() {
        _classCallCheck(this, ModelConditionsStep);

        return _possibleConstructorReturn(this, (ModelConditionsStep.__proto__ || Object.getPrototypeOf(ModelConditionsStep)).apply(this, arguments));
    }

    _createClass(ModelConditionsStep, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var model = this.props.model;
            var _onChange = function _onChange(input) {
                _this2.props.setModel(input);
            };

            return _react2.default.createElement(
                'div',
                { className: 'configuration-step' },
                _react2.default.createElement(
                    'h4',
                    { className: 'title is-5' },
                    _react2.default.createElement(
                        'span',
                        { className: 'badge' },
                        '3'
                    ),
                    '\xA0Select Modeling Conditions\xA0',
                    _react2.default.createElement(
                        'span',
                        { 'data-tip': true,
                            'data-for': 'modeling-info',
                            style: { 'fontSize': '.8em' }
                        },
                        '\u24D8'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'step-content' },
                    _react2.default.createElement(
                        _reactTooltip2.default,
                        { id: 'modeling-info', className: 'tooltip' },
                        'You can select one or more future time ranges (it will overlay all selections on a single map) as well as the modeling conditions to predict future regions that will have climactic conditions similar to the distribution you have selected. RCP 4.5 is a more conservative estimate of future CO2 levels than RCP 8.5.'
                    ),
                    _react2.default.createElement(
                        'em',
                        null,
                        'Select a future time range and a model'
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        '\xA0'
                    ),
                    _react2.default.createElement(
                        'table',
                        { className: 'table is-fullwidth modeling-table' },
                        _react2.default.createElement(
                            'tbody',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement('td', null),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    'RCP 4.5'
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    'RCP 8.5'
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    '2011 - 2040'
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement('input', { onChange: function onChange(e) {
                                            return _onChange(e.target.value);
                                        },
                                        value: 'rcp45_2025',
                                        type: 'checkbox',
                                        checked: model.rcp45_2025
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement('input', { onChange: function onChange(e) {
                                            return _onChange(e.target.value);
                                        },
                                        value: 'rcp85_2025',
                                        type: 'checkbox',
                                        checked: model.rcp85_2025
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    '2041 - 2070'
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement('input', { onChange: function onChange(e) {
                                            return _onChange(e.target.value);
                                        },
                                        value: 'rcp45_2055',
                                        type: 'checkbox',
                                        checked: model.rcp45_2055
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement('input', { onChange: function onChange(e) {
                                            return _onChange(e.target.value);
                                        },
                                        value: 'rcp85_2055',
                                        type: 'checkbox',
                                        checked: model.rcp85_2055
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    '2071 - 2100'
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement('input', { onChange: function onChange(e) {
                                            return _onChange(e.target.value);
                                        },
                                        value: 'rcp45_2085',
                                        type: 'checkbox',
                                        checked: model.rcp45_2085
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement('input', { onChange: function onChange(e) {
                                            return _onChange(e.target.value);
                                        },
                                        value: 'rcp85_2085',
                                        type: 'checkbox',
                                        checked: model.rcp85_2085
                                    })
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        '\xA0'
                    )
                )
            );
        }
    }]);

    return ModelConditionsStep;
}(_react.Component);

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setModel: _configuration.setModel }, dispatch);
}

var mapStateToProps = function mapStateToProps(state) {
    var model = state.configuration.model;

    return { model: model };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ModelConditionsStep);

/***/ }),

/***/ 0:
/*!*********************************************************!*\
  !*** multi babel-polyfill ./src/index ./scss/spht.scss ***!
  \*********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! babel-polyfill */"j1ja");
__webpack_require__(/*! ./src/index */"lVK7");
module.exports = __webpack_require__(/*! ./scss/spht.scss */"p1Rc");


/***/ }),

/***/ "0S2f":
/*!*******************************!*\
  !*** ./src/reducers/error.js ***!
  \*******************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _error = __webpack_require__(/*! ../actions/error */ "9sri");

var _utils = __webpack_require__(/*! ../utils */ "L/hj");

var defaultState = {
    error: null,
    details: null,
    showModal: false
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    switch (action.type) {
        case _error.SET_ERROR:
            return (0, _utils.morph)(state, { error: action.error, details: action.details, showModal: true });

        case _error.CLEAR_ERROR:
            return (0, _utils.morph)(state, { error: null, details: null, showModal: false });
    }

    return state;
};

/***/ }),

/***/ "0hgf":
/*!********************************************!*\
  !*** ./src/containers/DistributionStep.js ***!
  \********************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(/*! react */ "GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(/*! react-redux */ "RH2O");

var _redux = __webpack_require__(/*! redux */ "2KeS");

var _configuration = __webpack_require__(/*! ../actions/configuration */ "gcEp");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DistributionStep = function (_Component) {
    _inherits(DistributionStep, _Component);

    function DistributionStep() {
        _classCallCheck(this, DistributionStep);

        return _possibleConstructorReturn(this, (DistributionStep.__proto__ || Object.getPrototypeOf(DistributionStep)).apply(this, arguments));
    }

    _createClass(DistributionStep, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var distribution = this.props.distribution;

            return _react2.default.createElement(
                'div',
                { className: 'configuration-step' },
                _react2.default.createElement(
                    'h4',
                    { className: 'title is-5' },
                    _react2.default.createElement(
                        'span',
                        { className: 'badge' },
                        '2'
                    ),
                    ' Select Species Distribution Record'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'step-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'select' },
                        _react2.default.createElement(
                            'select',
                            {
                                value: distribution,
                                onChange: function onChange(e) {
                                    return _this2.props.setDistribution(e.target.value);
                                } },
                            _react2.default.createElement(
                                'option',
                                { value: '1961_1990' },
                                '1961 - 1990'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: '1981_2010' },
                                '1981 - 2010'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        '\xA0'
                    )
                )
            );
        }
    }]);

    return DistributionStep;
}(_react.Component);

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ setDistribution: _configuration.setDistribution }, dispatch);
}

var mapStateToProps = function mapStateToProps(state) {
    var distribution = state.configuration.distribution;

    return { distribution: distribution };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DistributionStep);

/***/ }),

/***/ "1Whh":
/*!****************************************!*\
  !*** ./src/containers/DownloadStep.js ***!
  \****************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(/*! react */ "GiK3");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(/*! redux */ "2KeS");

var _reactRedux = __webpack_require__(/*! react-redux */ "RH2O");

var _reactTooltip = __webpack_require__(/*! react-tooltip */ "Hh2+");

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _ModalCard = __webpack_require__(/*! ../components/ModalCard */ "3LV8");

var _ModalCard2 = _interopRequireDefault(_ModalCard);

var _DownloadConfiguration = __webpack_require__(/*! ../components/DownloadConfiguration */ "M/32");

var _DownloadConfiguration2 = _interopRequireDefault(_DownloadConfiguration);

var _colors = __webpack_require__(/*! ../colors */ "Phvt");

var _colors2 = _interopRequireDefault(_colors);

var _utils = __webpack_require__(/*! ../utils */ "L/hj");

var _report = __webpack_require__(/*! ../actions/report */ "uwbp");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DownloadStep = function (_Component) {
    _inherits(DownloadStep, _Component);

    function DownloadStep(props) {
        _classCallCheck(this, DownloadStep);

        var _this = _possibleConstructorReturn(this, (DownloadStep.__proto__ || Object.getPrototypeOf(DownloadStep)).call(this, props));

        _this.config = null;
        _this.state = { showModal: false };
        return _this;
    }

    _createClass(DownloadStep, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                map = _props.map,
                configuration = _props.configuration,
                advanced = _props.advanced,
                isFetching = _props.isFetching,
                errorModal = _props.errorModal,
                _onSubmit = _props.onSubmit;
            var showModal = this.state.showModal;
            var center = map.center,
                zoom = map.zoom,
                basemap = map.basemap,
                layerOpacity = map.layerOpacity;
            var colorScheme = advanced.colorScheme;
            var species = configuration.species,
                distribution = configuration.distribution,
                model = configuration.model;


            return _react2.default.createElement(
                'div',
                { className: 'configuration-step' },
                _react2.default.createElement(
                    'h4',
                    { className: 'title is-5' },
                    _react2.default.createElement(
                        'span',
                        { className: 'badge' },
                        '4'
                    ),
                    ' Download ',
                    _react2.default.createElement(
                        'span',
                        { 'data-tip': true, 'data-for': 'download-info', style: { 'fontSize': '.8em' } },
                        '\u24D8'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'step-content' },
                    _react2.default.createElement(
                        _reactTooltip2.default,
                        { id: 'download-info', className: 'tooltip' },
                        'The map shows current areas of species distribution and future areas with projected climactic conditions similar to current conditions. The overlap of the two represents predicted safe zones to promote species colonization.'
                    ),
                    _react2.default.createElement(
                        'em',
                        null,
                        'Download results to a pdf'
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        '\xA0'
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            disabled: species === null,
                            className: 'button',
                            onClick: function onClick() {
                                _this2.setState({ showModal: true });
                                _this2.config.refresh();
                            }
                        },
                        'Download'
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        '\xA0'
                    )
                ),
                _react2.default.createElement(
                    _ModalCard2.default,
                    {
                        open: showModal && !errorModal,
                        title: 'Download PDF',
                        disabled: isFetching,
                        onClose: function onClose() {
                            return _this2.setState({ showModal: false });
                        },
                        onSubmit: function onSubmit() {
                            return _onSubmit(_this2.config.getConfiguration());
                        },
                        submitLabel: 'Download PDF',
                        className: 'pdf-preview'
                    },
                    isFetching ? _react2.default.createElement(
                        'div',
                        { className: 'pageloader is-active' },
                        _react2.default.createElement(
                            'span',
                            { className: 'title' },
                            'Creating report...'
                        )
                    ) : null,
                    species === null || isFetching ? null : _react2.default.createElement(_DownloadConfiguration2.default, {
                        ref: function ref(input) {
                            return _this2.config = input;
                        },
                        open: showModal,
                        center: center,
                        zoom: zoom,
                        basemap: basemap,
                        urls: (0, _utils.getLayerURLs)(species, distribution, model),
                        colorScheme: _colors2.default[colorScheme],
                        opacity: layerOpacity
                    })
                )
            );
        }
    }]);

    return DownloadStep;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref) {
    var map = _ref.map,
        configuration = _ref.configuration,
        advanced = _ref.advanced,
        report = _ref.report,
        error = _ref.error;

    return { map: map, configuration: configuration, advanced: advanced, isFetching: report.reportIsFetching, errorModal: error.showModal };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        onSubmit: function onSubmit(mapConfig) {
            return function (_, getState) {
                var _getState = getState(),
                    map = _getState.map,
                    advanced = _getState.advanced,
                    configuration = _getState.configuration;

                var bounds = mapConfig.bounds,
                    zoom = mapConfig.zoom;
                var basemap = map.basemap,
                    layerOpacity = map.layerOpacity;
                var colorScheme = advanced.colorScheme;
                var species = configuration.species,
                    distribution = configuration.distribution,
                    model = configuration.model;

                dispatch((0, _report.createReport)(bounds, zoom, basemap.url, _colors2.default[colorScheme], species, distribution, Object.keys(model).filter(function (item) {
                    return model[item];
                }), layerOpacity));
            };
        }
    }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DownloadStep);

/***/ }),

/***/ "3LV8":
/*!*************************************!*\
  !*** ./src/components/ModalCard.js ***!
  \*************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(/*! react */ "GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(/*! react-dom */ "O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(/*! prop-types */ "KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalCard = function (_React$Component) {
    _inherits(ModalCard, _React$Component);

    function ModalCard(props) {
        _classCallCheck(this, ModalCard);

        return _possibleConstructorReturn(this, (ModalCard.__proto__ || Object.getPrototypeOf(ModalCard)).call(this, props));
    }

    _createClass(ModalCard, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                open = _props.open,
                title = _props.title,
                _props$disabled = _props.disabled,
                disabled = _props$disabled === undefined ? false : _props$disabled,
                children = _props.children,
                onClose = _props.onClose,
                _props$onSubmit = _props.onSubmit,
                onSubmit = _props$onSubmit === undefined ? null : _props$onSubmit,
                _props$submitLabel = _props.submitLabel,
                submitLabel = _props$submitLabel === undefined ? 'Submit' : _props$submitLabel,
                _props$cancelLabel = _props.cancelLabel,
                cancelLabel = _props$cancelLabel === undefined ? 'Cancel' : _props$cancelLabel,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className;


            return _reactDom2.default.createPortal(_react2.default.createElement(
                'div',
                { className: 'modal ' + (open ? 'is-active' : '') + ' ' + className },
                _react2.default.createElement('div', { className: 'modal-background' }),
                _react2.default.createElement(
                    'div',
                    { className: 'modal-card' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-card-head' },
                        _react2.default.createElement(
                            'p',
                            { className: 'modal-card-title' },
                            title
                        ),
                        _react2.default.createElement('button', { className: 'delete', 'aria-label': 'close', onClick: function onClick() {
                                return onClose();
                            } })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-card-body' },
                        children
                    ),
                    onSubmit === null ? null : _react2.default.createElement(
                        'div',
                        { className: 'modal-card-foot justify-right' },
                        _react2.default.createElement(
                            'button',
                            { className: 'button', onClick: function onClick() {
                                    return onClose();
                                } },
                            cancelLabel
                        ),
                        _react2.default.createElement(
                            'button',
                            { disabled: disabled, className: 'button is-primary', onClick: function onClick() {
                                    return onSubmit();
                                } },
                            submitLabel
                        )
                    )
                )
            ), window.document.body);
        }
    }]);

    return ModalCard;
}(_react2.default.Component);

ModalCard.propTypes = {
    open: _propTypes2.default.bool.isRequired,
    title: _propTypes2.default.string.isRequired,
    disabled: _propTypes2.default.bool,
    children: _propTypes2.default.node,
    onClose: _propTypes2.default.func.isRequired,
    onSubmit: _propTypes2.default.func,
    submitLabel: _propTypes2.default.string
};

exports.default = ModalCard;

/***/ }),

/***/ "3USj":
/*!****************************!*\
  !*** ./images/fs_logo.png ***!
  \****************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/static/images/fs_logo.df5bed988ebaec2cb3b77303145f913d.png";

/***/ }),

/***/ "9sri":
/*!******************************!*\
  !*** ./src/actions/error.js ***!
  \******************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SET_ERROR = exports.SET_ERROR = 'SET_ERROR';
var CLEAR_ERROR = exports.CLEAR_ERROR = 'CLEAR_ERROR';

var setError = exports.setError = function setError(error, details) {
    return {
        type: SET_ERROR,
        error: error,
        details: details
    };
};

var clearError = exports.clearError = function clearError() {
    return {
        type: CLEAR_ERROR
    };
};

/***/ }),

/***/ "9vC2":
/*!**********************************!*\
  !*** ./src/components/Navbar.js ***!
  \**********************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(/*! react */ "GiK3");

var _react2 = _interopRequireDefault(_react);

var _ModalCard = __webpack_require__(/*! ./ModalCard */ "3LV8");

var _ModalCard2 = _interopRequireDefault(_ModalCard);

var _fs_logo = __webpack_require__(/*! ../../images/fs_logo.png */ "3USj");

var _fs_logo2 = _interopRequireDefault(_fs_logo);

var _osu_logo = __webpack_require__(/*! ../../images/osu_logo.png */ "uTt8");

var _osu_logo2 = _interopRequireDefault(_osu_logo);

var _cbi_logo = __webpack_require__(/*! ../../images/cbi_logo.png */ "Ijft");

var _cbi_logo2 = _interopRequireDefault(_cbi_logo);

var _nw_climate_hub_logo = __webpack_require__(/*! ../../images/nw_climate_hub_logo.png */ "nvBQ");

var _nw_climate_hub_logo2 = _interopRequireDefault(_nw_climate_hub_logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Navbar = function (_React$Component) {
    _inherits(Navbar, _React$Component);

    function Navbar(props) {
        _classCallCheck(this, Navbar);

        var _this = _possibleConstructorReturn(this, (Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call(this, props));

        _this.state = {
            isActive: false,
            modal: null
        };
        return _this;
    }

    _createClass(Navbar, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var modal = this.state.modal;

            var isActive = this.state.isActive ? 'is-active ' : '';

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'navbar is-dark', role: 'navigation', 'aria-label': 'main navigation' },
                    _react2.default.createElement(
                        'div',
                        { className: 'navbar-brand' },
                        _react2.default.createElement(
                            'a',
                            { className: 'navbar-item is-size-4 has-text-weight-bold', href: '#' },
                            'Species Potential Habitat Tool'
                        ),
                        _react2.default.createElement(
                            'a',
                            { role: 'button',
                                className: isActive + "navbar-burger",
                                'aria-label': 'menu',
                                'aria-expanded': 'false',
                                onClick: function onClick(e) {
                                    _this2.setState({ isActive: !_this2.state.isActive });
                                } },
                            _react2.default.createElement('span', { 'aria-hidden': 'true' }),
                            _react2.default.createElement('span', { 'aria-hidden': 'true' }),
                            _react2.default.createElement('span', { 'aria-hidden': 'true' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: isActive + "navbar-menu" },
                        _react2.default.createElement(
                            'div',
                            { className: 'navbar-end' },
                            _react2.default.createElement(
                                _ModalCard2.default,
                                {
                                    open: modal === 'people',
                                    title: 'People',
                                    onClose: function onClose() {
                                        return _this2.setState({ modal: null });
                                    }
                                },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'section',
                                        { className: 'modal-card-body' },
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            'The Species Habitat Potential Tool is a collaboration between the US Forest Service, Oregon State University, and the Conservation Biology Institute. Initial conceptualization and development was done by Glenn Howe at Oregon State University College of Forestry and Brad St.Clair at the USFS Pacific Northwest Research Station, with considerable input from Ron Beloin while he was working at Oregon State University. The Conservation Biology Institute was brought onboard to bring the project to fruition through their expertise in web site design and programming for spatial applications. Personnel at the Conservation Biology Institute include Dominique Bachelet (project co-PI), Nikolas Stevenson-Molnar (tool developer), and Brendan Ward (project manager).'
                                        ),
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            'Initial funding for the Species Habitat Potential Tool came from the US Forest Service Washington Office. Subsequent funding came from the USFS Pacific Northwest Research Station, Oregon State University, Conservation Biology Institute, the USDA Northwest Climate Hub, and Natural Resources Canada.'
                                        ),
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            '\xA0'
                                        ),
                                        _react2.default.createElement(
                                            'p',
                                            { className: 'columns' },
                                            _react2.default.createElement(
                                                'a',
                                                { className: 'column', href: 'http://www.fs.fed.us/', target: '_blank' },
                                                _react2.default.createElement('img', { src: _fs_logo2.default, alt: 'Forest Service' })
                                            ),
                                            _react2.default.createElement(
                                                'a',
                                                { className: 'column', href: 'http://oregonstate.edu/', target: '_blank' },
                                                _react2.default.createElement('img', { src: _osu_logo2.default, alt: 'Oregon State University' })
                                            ),
                                            _react2.default.createElement(
                                                'span',
                                                null,
                                                '\xA0'
                                            ),
                                            _react2.default.createElement(
                                                'a',
                                                { className: 'column', href: 'http://consbio.org', target: '_blank' },
                                                _react2.default.createElement('img', { src: _cbi_logo2.default, alt: 'Conservation Biology Institute' })
                                            ),
                                            _react2.default.createElement(
                                                'span',
                                                null,
                                                '\xA0'
                                            ),
                                            _react2.default.createElement(
                                                'a',
                                                { className: 'column is-half', href: 'https://www.climatehubs.oce.usda.gov/northwest', target: '_blank' },
                                                _react2.default.createElement('img', { src: _nw_climate_hub_logo2.default, alt: 'NW Climate Hub' })
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            '\xA0'
                                        ),
                                        _react2.default.createElement(
                                            'h4',
                                            { className: 'title is-4' },
                                            'Contact Information'
                                        ),
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            'Dr. Glenn Howe \u2013 Co-Principal Investigator',
                                            _react2.default.createElement('br', null),
                                            'Associate Professor, Department of Forest Ecosystems and Society',
                                            _react2.default.createElement('br', null),
                                            'Oregon State University, Corvallis, Oregon, USA',
                                            _react2.default.createElement('br', null),
                                            _react2.default.createElement(
                                                'a',
                                                { href: 'mailto:glenn.howe@oregonstate.edu' },
                                                'glenn.howe@oregonstate.edu'
                                            )
                                        ),
                                        _react2.default.createElement('br', null),
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            'Dr. Brad St.Clair \u2013 Co-Principal Investigator',
                                            _react2.default.createElement('br', null),
                                            'Research Geneticist, Pacific Northwest Research Station',
                                            _react2.default.createElement('br', null),
                                            'USDA Forest Service, Corvallis, Oregon, USA',
                                            _react2.default.createElement('br', null),
                                            _react2.default.createElement(
                                                'a',
                                                { href: 'mailto:bstclair@fs.fed.us' },
                                                'bstclair@fs.fed.us'
                                            )
                                        ),
                                        _react2.default.createElement('br', null),
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            'Nikolas Stevenson-Molnar \u2013 Tool Developer',
                                            _react2.default.createElement('br', null),
                                            'Software Engineer',
                                            _react2.default.createElement('br', null),
                                            'Conservation Biology Institute, Corvallis, Oregon, USA',
                                            _react2.default.createElement('br', null),
                                            _react2.default.createElement(
                                                'a',
                                                { href: 'mailto:nik.molnar@consbio.org' },
                                                'nik.molnar@consbio.org'
                                            )
                                        ),
                                        _react2.default.createElement('br', null),
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            'Ken Ferschweiler \u2013 Tool Developer',
                                            _react2.default.createElement('br', null),
                                            'Senior Software Architect, Modeler',
                                            _react2.default.createElement('br', null),
                                            'Conservation Biology Institute, Corvallis, Oregon, USA',
                                            _react2.default.createElement('br', null),
                                            _react2.default.createElement(
                                                'a',
                                                { href: 'mailto:ken@consbio.org' },
                                                'ken@consbio.org'
                                            )
                                        ),
                                        _react2.default.createElement('br', null),
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            'Bill Klinkow \u2013 Tool Developer',
                                            _react2.default.createElement('br', null),
                                            'Software Engineer',
                                            _react2.default.createElement('br', null),
                                            'Conservation Biology Institute, Corvallis, Oregon, USA',
                                            _react2.default.createElement('br', null),
                                            _react2.default.createElement(
                                                'a',
                                                { href: 'mailto:bill.klinkow@consbio.org' },
                                                'bill.klinkow@consbio.org'
                                            )
                                        ),
                                        _react2.default.createElement('br', null),
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            'Brendan Ward \u2013 Project Manager',
                                            _react2.default.createElement('br', null),
                                            'Conservation Biologist/GIS Analyst/Software Engineer',
                                            _react2.default.createElement('br', null),
                                            'Conservation Biology Institute, Corvallis, Oregon, USA',
                                            _react2.default.createElement('br', null),
                                            _react2.default.createElement(
                                                'a',
                                                { href: 'mailto:bcward@consbio.org' },
                                                'bcward@consbio.org'
                                            )
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'a',
                                {
                                    className: 'navbar-item',
                                    onClick: function onClick() {
                                        return _this2.setState({ modal: 'people' });
                                    }
                                },
                                'People'
                            ),
                            _react2.default.createElement(
                                'a',
                                { className: 'navbar-item', href: 'https://github.com/consbio/spht/' },
                                'Source Code'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Navbar;
}(_react2.default.Component);

exports.default = Navbar;

/***/ }),

/***/ "ASCW":
/*!*******************!*\
  !*** ./src/io.js ***!
  \*******************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.executeGPTask = exports.ioDelete = exports.put = exports.post = exports.get = exports.urlEncode = undefined;

var _isomorphicFetch = __webpack_require__(/*! isomorphic-fetch */ "j9g7");

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _utils = __webpack_require__(/*! ./utils */ "L/hj");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var urlEncode = exports.urlEncode = function urlEncode(data) {
    var items = Object.keys(data).map(function (item) {
        return encodeURIComponent(item) + '=' + encodeURIComponent(data[item]);
    });

    return items.join('&');
};

var get = exports.get = function get(url) {
    return (0, _isomorphicFetch2.default)(url, {
        credentials: 'same-origin',
        headers: {
            'Accept': 'application/json, */*'
        }
    });
};

var post = exports.post = function post(url, data) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var method = options.method;


    if (!method) {
        method = 'POST';
    }

    if (data) {
        data = JSON.stringify(data);
    }

    return (0, _isomorphicFetch2.default)(url, {
        method: method,
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json, */*',
            'X-CSRFToken': (0, _utils.getCookies)().csrftoken
        },
        body: data
    });
};

var put = exports.put = function put(url, data, options) {
    return post(url, data, Object.assign({ method: 'PUT' }, options));
};

var ioDelete = exports.ioDelete = function ioDelete(url, options) {
    return post(url, null, Object.assign({ method: 'DELETE' }, options));
};

var executeGPTask = exports.executeGPTask = function executeGPTask(job, inputs) {
    var statusCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var data = {
        job: job,
        inputs: JSON.stringify(inputs)
    };

    var handleJSONResponse = function handleJSONResponse(response) {
        var status = response.status;


        if (status >= 200 && status < 300) {
            return response.json();
        } else {
            throw new Error('Bad response code:  ' + response.status);
        }
    };

    return post('/geoprocessing/rest/jobs/', data).then(handleJSONResponse).then(function (json) {
        var uuid = json.uuid;


        return new Promise(function (resolve, reject) {
            var pollStatus = function pollStatus() {
                get('/geoprocessing/rest/jobs/' + uuid + '/').then(handleJSONResponse).then(function (json) {
                    if (statusCallback !== null) {
                        statusCallback(json);
                    }

                    if (json.status === 'success') {
                        resolve(json);
                    } else if (json.status === 'failure') {
                        var err = new Error('Job failed');
                        err.json = json;
                        reject(err);
                    } else {
                        setTimeout(pollStatus, 1000);
                    }
                }).catch(function (err) {
                    return reject(err);
                });
            };

            setTimeout(pollStatus, 1000);
        });
    });
};

/***/ }),

/***/ "Age6":
/*!********************************!*\
  !*** ./src/reducers/report.js ***!
  \********************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _report = __webpack_require__(/*! ../actions/report */ "uwbp");

var _utils = __webpack_require__(/*! ../utils */ "L/hj");

var defaultState = {
    reportIsFetching: false
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    switch (action.type) {
        case _report.FETCH_REPORT:
            return (0, _utils.morph)(state, { reportIsFetching: true });

        case _report.RECEIVE_REPORT:
            return (0, _utils.morph)(state, { reportIsFetching: false });
    }

    return state;
};

/***/ }),

/***/ "ChGC":
/*!*******************************!*\
  !*** ./src/reducers/index.js ***!
  \*******************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(/*! redux */ "2KeS");

var _map = __webpack_require__(/*! ./map */ "nVyE");

var _map2 = _interopRequireDefault(_map);

var _runConfiguration = __webpack_require__(/*! ./runConfiguration */ "JKng");

var _runConfiguration2 = _interopRequireDefault(_runConfiguration);

var _advanced = __webpack_require__(/*! ./advanced */ "uCKC");

var _advanced2 = _interopRequireDefault(_advanced);

var _report = __webpack_require__(/*! ./report */ "Age6");

var _report2 = _interopRequireDefault(_report);

var _error = __webpack_require__(/*! ./error */ "0S2f");

var _error2 = _interopRequireDefault(_error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
    map: _map2.default,
    configuration: _runConfiguration2.default,
    advanced: _advanced2.default,
    report: _report2.default,
    error: _error2.default
});

/***/ }),

/***/ "EKQ1":
/*!************************!*\
  !*** ./src/species.js ***!
  \************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    pico: 'Lodgepole Pine',
    pisi: 'Sitka Spruce',
    psme: 'Douglas-fir',
    pipo: 'Ponderosa Pine',
    pien: 'Engelmann Spruce',
    lariocc: 'Western larch',
    pinumon: 'Western white pine'
};

/***/ }),

/***/ "Ijft":
/*!*****************************!*\
  !*** ./images/cbi_logo.png ***!
  \*****************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/static/images/cbi_logo.35bd053aed7d83000b6dc7770401edb6.png";

/***/ }),

/***/ "JKng":
/*!******************************************!*\
  !*** ./src/reducers/runConfiguration.js ***!
  \******************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(/*! ../utils */ "L/hj");

var defaultConfiguration = {
    species: null,
    distribution: '1961_1990',
    model: { rcp45_2025: false,
        rcp85_2025: false,
        rcp45_2055: false,
        rcp85_2055: false,
        rcp45_2085: false,
        rcp85_2085: false
    }
};

var configuration = function configuration() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultConfiguration;
    var action = arguments[1];

    switch (action.type) {
        case 'SELECT_SPECIES':
            return (0, _utils.morph)(state, { species: action.species });
        case 'SELECT_DISTRIBUTION':
            return (0, _utils.morph)(state, { distribution: action.distribution });
        case 'SELECT_MODEL':
            switch (action.model) {
                case 'rcp45_2025':
                    return (0, _utils.morph)(state, { model: (0, _utils.morph)(state.model, { rcp45_2025: !state.model.rcp45_2025 }) });
                case 'rcp85_2025':
                    return (0, _utils.morph)(state, { model: (0, _utils.morph)(state.model, { rcp85_2025: !state.model.rcp85_2025 }) });
                case 'rcp45_2055':
                    return (0, _utils.morph)(state, { model: (0, _utils.morph)(state.model, { rcp45_2055: !state.model.rcp45_2055 }) });
                case 'rcp85_2055':
                    return (0, _utils.morph)(state, { model: (0, _utils.morph)(state.model, { rcp85_2055: !state.model.rcp85_2055 }) });
                case 'rcp45_2085':
                    return (0, _utils.morph)(state, { model: (0, _utils.morph)(state.model, { rcp45_2085: !state.model.rcp45_2085 }) });
                case 'rcp85_2085':
                    return (0, _utils.morph)(state, { model: (0, _utils.morph)(state.model, { rcp85_2085: !state.model.rcp85_2085 }) });
            }

    }

    return state;
};

exports.default = configuration;

/***/ }),

/***/ "Jh0i":
/*!***************************************!*\
  !*** ./src/containers/SpeciesStep.js ***!
  \***************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(/*! react */ "GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(/*! react-redux */ "RH2O");

var _redux = __webpack_require__(/*! redux */ "2KeS");

var _configuration = __webpack_require__(/*! ../actions/configuration */ "gcEp");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SpeciesStep = function (_Component) {
    _inherits(SpeciesStep, _Component);

    function SpeciesStep() {
        _classCallCheck(this, SpeciesStep);

        return _possibleConstructorReturn(this, (SpeciesStep.__proto__ || Object.getPrototypeOf(SpeciesStep)).apply(this, arguments));
    }

    _createClass(SpeciesStep, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var species = this.props.species;
            return _react2.default.createElement(
                'div',
                { className: 'configuration-step' },
                _react2.default.createElement(
                    'h4',
                    { className: 'title is-5' },
                    _react2.default.createElement(
                        'span',
                        { className: 'badge' },
                        '1'
                    ),
                    ' Select Species'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'step-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'select' },
                        _react2.default.createElement(
                            'select',
                            {
                                value: species || "none",
                                onChange: function onChange(e) {
                                    var value = e.target.value;
                                    if (value === "none") {
                                        value = null;
                                    }
                                    _this2.props.onChange(value);
                                }
                            },
                            _react2.default.createElement(
                                'option',
                                { value: 'none' },
                                'Select'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: 'pico' },
                                'Lodgepole pine'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: 'psme' },
                                'Douglas-fir'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: 'pisi' },
                                'Sitka spruce'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: 'pipo' },
                                'Ponderosa pine'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: 'pien' },
                                'Engelmann spruce'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: 'lariocc' },
                                'Western larch'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: 'pinumon' },
                                'Western white pine'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    '\xA0'
                )
            );
        }
    }]);

    return SpeciesStep;
}(_react.Component);

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({ onChange: _configuration.setSpecies }, dispatch);
}

var mapStateToProps = function mapStateToProps(state) {
    var species = state.configuration.species;

    return { species: species };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SpeciesStep);

/***/ }),

/***/ "L/hj":
/*!**********************!*\
  !*** ./src/utils.js ***!
  \**********************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/* A shortcut for Object.assign({}, obj, props) */
var morph = exports.morph = function morph(obj) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.assign({}, obj, props);
};

var getLayerURLs = exports.getLayerURLs = function getLayerURLs(species, distribution, model) {
    if (species === null) {
        return [];
    }

    return ['/tiles/' + species + '_p' + distribution + '_800m_pa'].concat(Object.keys(model).filter(function (item) {
        return model[item];
    }).map(function (item) {
        return '/tiles/' + species + '_15gcm_' + item + '_pa';
    }));
};

var getCookies = exports.getCookies = function getCookies() {
    var cookies = {};

    document.cookie.split(';').forEach(function (item) {
        var _item$trim$split = item.trim().split('='),
            _item$trim$split2 = _slicedToArray(_item$trim$split, 2),
            name = _item$trim$split2[0],
            value = _item$trim$split2[1];

        cookies[name] = decodeURIComponent(value);
    });

    return cookies;
};

var rgbToHex = exports.rgbToHex = function rgbToHex(rgb) {
    return '#' + rgb.map(function (c) {
        return c.toString(16).padStart(2, '0');
    }).join('');
};

/***/ }),

/***/ "M/32":
/*!*************************************************!*\
  !*** ./src/components/DownloadConfiguration.js ***!
  \*************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(/*! react */ "GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(/*! prop-types */ "KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _leaflet = __webpack_require__(/*! leaflet */ "nrd6");

var _leaflet2 = _interopRequireDefault(_leaflet);

var _lethargy = __webpack_require__(/*! lethargy */ "n0/e");

var _HabitatLayer = __webpack_require__(/*! ../containers/Map/HabitatLayer */ "O7kx");

var _HabitatLayer2 = _interopRequireDefault(_HabitatLayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DownloadConfiguration = function (_React$Component) {
    _inherits(DownloadConfiguration, _React$Component);

    function DownloadConfiguration(props) {
        _classCallCheck(this, DownloadConfiguration);

        var _this = _possibleConstructorReturn(this, (DownloadConfiguration.__proto__ || Object.getPrototypeOf(DownloadConfiguration)).call(this, props));

        _this.mapNode = null;
        _this.map = null;
        _this.basemapLayer = null;
        _this.habitatLayer = null;
        return _this;
    }

    _createClass(DownloadConfiguration, [{
        key: 'refresh',
        value: function refresh() {
            var _this2 = this;

            setTimeout(function () {
                return _this2.map.invalidateSize();
            }, 1);
        }
    }, {
        key: 'getConfiguration',
        value: function getConfiguration() {
            var bounds = this.map.getBounds();

            return {
                bounds: [bounds.getWest(), bounds.getSouth(), bounds.getEast(), bounds.getNorth()],
                zoom: this.map.getZoom()
            };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                center = _props.center,
                zoom = _props.zoom,
                basemap = _props.basemap,
                urls = _props.urls,
                colorScheme = _props.colorScheme,
                opacity = _props.opacity;


            var lethargy = new _lethargy.Lethargy(7, 10, 0.05); // Help minimize jumpy zoom with Apple mice and trackpads
            _leaflet2.default.Map.ScrollWheelZoom.prototype._onWheelScroll = function (e) {
                _leaflet2.default.DomEvent.stop(e);

                if (lethargy.check(e) === false) {
                    return;
                }

                var delta = _leaflet2.default.DomEvent.getWheelDelta(e);
                if (delta <= -0.25) delta = -0.25;
                if (delta >= 0.25) delta = 0.25;

                this._delta += delta;
                this._lastMousePos = this._map.mouseEventToContainerPoint(e);

                this._performZoom();
            };

            this.map = _leaflet2.default.map(this.mapNode, {
                center: center,
                zoom: zoom,
                minZoom: 3,
                maxZoom: 13
            });

            this.map.zoomControl.setPosition('topright');
            this.basemapLayer = _leaflet2.default.tileLayer(basemap.url, basemap.options).addTo(this.map);
            this.habitatLayer = new _HabitatLayer2.default(urls, colorScheme).addTo(this.map);
            this.habitatLayer.setOpacity(opacity);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var _props2 = this.props,
                center = _props2.center,
                zoom = _props2.zoom,
                basemap = _props2.basemap,
                urls = _props2.urls,
                colorScheme = _props2.colorScheme,
                opacity = _props2.opacity;


            if (center[0] !== prevProps.center[0] || center[1] !== prevProps.center[1]) {
                this.map.setView(center, zoom);
            }

            if (basemap.url !== prevProps.basemap.url) {
                this.basemapLayer.setUrl(basemap.url);
                _leaflet2.default.setOptions(this.basemapLayer, basemap.options);
            }

            var habitatChanged = !urls.every(function (url, i) {
                return url === prevProps.urls[i];
            }) || JSON.stringify(colorScheme) !== JSON.stringify(prevProps.colorScheme);
            if (habitatChanged) {
                this.habitatLayer.setUrls(urls, colorScheme);
            }

            if (opacity !== prevProps.opacity) {
                this.habitatLayer.setOpacity(opacity);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                'div',
                { className: 'preview-map-container' },
                _react2.default.createElement('div', { ref: function ref(input) {
                        return _this3.mapNode = input;
                    }, className: 'preview-map' })
            );
        }
    }]);

    return DownloadConfiguration;
}(_react2.default.Component);

DownloadConfiguration.propTypes = {
    center: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
    zoom: _propTypes2.default.number.isRequired,
    basemap: _propTypes2.default.shape({
        url: _propTypes2.default.string.isRequired,
        options: _propTypes2.default.object.isRequired
    }).isRequired,
    urls: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
    colorScheme: _propTypes2.default.shape({
        single: _propTypes2.default.string.isRequired,
        kept: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.number)).isRequired,
        appeared: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.number)).isRequired
    }).isRequired,
    opacity: _propTypes2.default.number.isRequired
};

exports.default = DownloadConfiguration;

/***/ }),

/***/ "O7kx":
/*!********************************************!*\
  !*** ./src/containers/Map/HabitatLayer.js ***!
  \********************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getColors = undefined;

var _leaflet = __webpack_require__(/*! leaflet */ "nrd6");

var _leaflet2 = _interopRequireDefault(_leaflet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getColors = exports.getColors = function getColors(ramp, layerCount) {
    var colors = [].concat(_toConsumableArray(Array(layerCount).keys())).map(function (i) {
        return ramp[Math.ceil(i * ramp.length / layerCount)];
    });
    colors[colors.length - 1] = ramp[ramp.length - 1];
    return colors;
};

var HabitatLayer = _leaflet.GridLayer.extend({
    urls: [],
    colorScheme: null,

    initialize: function initialize(urls, colorScheme) {
        this.urls = urls;
        this.colorScheme = colorScheme;
    },

    setUrls: function setUrls(urls, colorScheme) {
        this.urls = urls;
        this.colorScheme = colorScheme || this.colorScheme;
        this.redraw();
    },

    createTile: function createTile(coords, done) {
        var tile = _leaflet2.default.DomUtil.create('div', 'leaflet-tile');
        var size = this.getTileSize();
        var canvas = _leaflet2.default.DomUtil.create('canvas', 'habitat-canvas', tile);
        canvas.width = size.x;
        canvas.height = size.y;

        var _colorScheme = this.colorScheme,
            single = _colorScheme.single,
            kept = _colorScheme.kept,
            appeared = _colorScheme.appeared;


        var promises = this.urls.map(function (url) {
            return new Promise(function (resolve) {
                var img = new Image();
                img.onload = function () {
                    return resolve(img);
                };
                img.src = url + '/' + coords.z + '/' + coords.x + '/' + coords.y + '.png';
            });
        });

        Promise.all(promises).then(function (images) {
            if (images.length === 1) {
                var c = canvas;
                var ctx = c.getContext('2d');
                ctx.globalCompositeOperation = 'source-out';
                ctx.drawImage(images[0], 0, 0);
                ctx.globalCompositeOperation = 'source-atop';
                ctx.fillStyle = single;
                ctx.fillRect(0, 0, c.width, c.height);
            } else if (images.length > 1) {
                var keptColors = getColors(kept, images.length);
                var addedColors = getColors(appeared, images.length);

                var source = images.shift();
                var _ctx = canvas.getContext('2d');
                _ctx.globalCompositeOperation = 'source-out';
                _ctx.drawImage(source, 0, 0);
                _ctx.globalCompositeOperation = 'source-atop';
                _ctx.fillStyle = 'rgb(' + keptColors[0] + ')';
                _ctx.fillRect(0, 0, size.x, size.y);
                var outputImageData = _ctx.getImageData(0, 0, size.x, size.y);

                var sourceCanvas = document.createElement('canvas');
                sourceCanvas.width = size.x;
                sourceCanvas.height = size.y;
                var sourceCtx = sourceCanvas.getContext('2d');
                sourceCtx.globalCompositeOperation = 'source-over';
                sourceCtx.drawImage(source, 0, 0);
                var sourceData = sourceCtx.getImageData(0, 0, sourceCanvas.width, sourceCanvas.height).data;

                var layers = images.map(function (image) {
                    var canvas = document.createElement('canvas');
                    canvas.width = size.x;
                    canvas.height = size.y;
                    var ctx = canvas.getContext('2d');
                    ctx.globalCompositeOperation = 'source-over';
                    ctx.drawImage(image, 0, 0);
                    return [canvas, ctx.getImageData(0, 0, canvas.width, canvas.height).data];
                });

                var data = outputImageData.data;

                for (var i = 3, len = data.length; i < len; i += 4) {
                    var colors = void 0;
                    if (sourceData[i] > 0) {
                        colors = keptColors;
                    } else {
                        colors = addedColors;
                    }

                    var count = 0;
                    for (var j = 0; j < layers.length; j++) {
                        if (layers[j][1][i] > 0) {
                            count++;
                        }
                    }

                    if (count > 0) {
                        data.set([].concat(_toConsumableArray(colors[count]), [255]), i - 3);
                    }
                }

                _ctx.putImageData(outputImageData, 0, 0);
            }
            done(null, tile);
        }).catch(function (err) {
            return console.log(err);
        });

        return tile;
    }
});

exports.default = HabitatLayer;

/***/ }),

/***/ "Phvt":
/*!***********************!*\
  !*** ./src/colors.js ***!
  \***********************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [{
    single: '#407c2b',
    kept: [[255, 255, 0], [236, 242, 4], [217, 229, 9], [198, 216, 13], [153, 185, 23], [109, 155, 33], [64, 124, 43]],
    appeared: [[0, 0, 0], [239, 243, 255], [198, 219, 239], [158, 202, 225], [107, 174, 214], [49, 130, 189], [8, 81, 156]]
}, {
    single: '#388E36',
    kept: [[255, 109, 0], [255, 151, 0], [255, 192, 0], [255, 234, 0], [189, 203, 20], [122, 173, 40], [56, 142, 54]],
    appeared: [[0, 0, 0], [239, 243, 255], [198, 219, 239], [158, 202, 225], [107, 174, 214], [49, 130, 189], [8, 81, 156]]
}];

/***/ }),

/***/ "YCZr":
/*!*******************************!*\
  !*** ./src/components/App.js ***!
  \*******************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(/*! react */ "GiK3");

var _react2 = _interopRequireDefault(_react);

var _Map = __webpack_require__(/*! ../containers/Map */ "tDg6");

var _Map2 = _interopRequireDefault(_Map);

var _Navbar = __webpack_require__(/*! ./Navbar */ "9vC2");

var _Navbar2 = _interopRequireDefault(_Navbar);

var _Sidebar = __webpack_require__(/*! ./Sidebar */ "o3wj");

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _ErrorModal = __webpack_require__(/*! ../containers/ErrorModal */ "lVok");

var _ErrorModal2 = _interopRequireDefault(_ErrorModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return _react2.default.createElement(
        'div',
        { className: 'spht-app' },
        _react2.default.createElement(_Navbar2.default, null),
        _react2.default.createElement(_ErrorModal2.default, null),
        _react2.default.createElement(
            'div',
            { className: 'columns is-gapless' },
            _react2.default.createElement(
                'div',
                { className: 'column is-narrow sidebar' },
                _react2.default.createElement(_Sidebar2.default, null)
            ),
            _react2.default.createElement(
                'div',
                { className: 'column map' },
                _react2.default.createElement(_Map2.default, null)
            )
        )
    );
};

/***/ }),

/***/ "Ytz3":
/*!****************************!*\
  !*** ./src/actions/map.js ***!
  \****************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SET_MAP_CENTER = exports.SET_MAP_CENTER = 'SET_MAP_CENTER';
var SET_MAP_ZOOM = exports.SET_MAP_ZOOM = 'SET_MAP_ZOOM';
var SET_MAP_POINT = exports.SET_MAP_POINT = 'SET_MAP_POINT';
var SET_MAP_Y = exports.SET_MAP_Y = 'SET_MAP_Y';
var SET_MAP_X = exports.SET_MAP_X = 'SET_MAP_X';
var SET_LAYER_OPACITY = exports.SET_LAYER_OPACITY = 'SET_LAYER_OPACITY';
var SET_BASEMAP = exports.SET_BASEMAP = 'SET_BASEMAP';

var setMapCenter = exports.setMapCenter = function setMapCenter(center) {
    return {
        type: SET_MAP_CENTER,
        center: center
    };
};

var setMapZoom = exports.setMapZoom = function setMapZoom(zoom) {
    return {
        type: SET_MAP_ZOOM,
        zoom: zoom
    };
};

var setMapPoint = exports.setMapPoint = function setMapPoint(x, y) {
    return {
        type: SET_MAP_POINT,
        point: { x: x, y: y }
    };
};

var setMapLat = exports.setMapLat = function setMapLat(y) {
    return {
        type: SET_MAP_Y,
        y: y
    };
};

var setMapLon = exports.setMapLon = function setMapLon(x) {
    return {
        type: SET_MAP_X,
        x: x
    };
};

var setLayerOpacity = exports.setLayerOpacity = function setLayerOpacity(input) {
    return {
        type: SET_LAYER_OPACITY,
        layerOpacity: input
    };
};

var setBasemap = exports.setBasemap = function setBasemap(basemap) {
    return {
        type: SET_BASEMAP,
        basemap: basemap
    };
};

/***/ }),

/***/ "fgrL":
/*!*********************************!*\
  !*** ./src/actions/advanced.js ***!
  \*********************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SET_COLOR_SCHEME = exports.SET_COLOR_SCHEME = 'SET_COLOR_SCHEME';

var setColorScheme = exports.setColorScheme = function setColorScheme(index) {
    return {
        type: SET_COLOR_SCHEME,
        index: index
    };
};

/***/ }),

/***/ "gcEp":
/*!**************************************!*\
  !*** ./src/actions/configuration.js ***!
  \**************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setSpecies = setSpecies;
exports.setDistribution = setDistribution;
exports.setModel = setModel;
function setSpecies(input) {
    return {
        type: 'SELECT_SPECIES',
        species: input
    };
}

function setDistribution(input) {
    return {
        type: 'SELECT_DISTRIBUTION',
        distribution: input
    };
}

function setModel(input) {
    return {
        type: 'SELECT_MODEL',
        model: input
    };
}

/***/ }),

/***/ "id1v":
/*!***********************************!*\
  !*** ./src/containers/Map/Map.js ***!
  \***********************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(/*! react */ "GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(/*! react-redux */ "RH2O");

var _map = __webpack_require__(/*! ../../actions/map */ "Ytz3");

var _species = __webpack_require__(/*! ../../species */ "EKQ1");

var _species2 = _interopRequireDefault(_species);

var _colors = __webpack_require__(/*! ../../colors */ "Phvt");

var _colors2 = _interopRequireDefault(_colors);

var _lethargy = __webpack_require__(/*! lethargy */ "n0/e");

var _leaflet = __webpack_require__(/*! leaflet */ "nrd6");

var _leaflet2 = _interopRequireDefault(_leaflet);

__webpack_require__(/*! leaflet-basemaps */ "2W7V");

__webpack_require__(/*! leaflet-zoombox */ "trVa");

__webpack_require__(/*! leaflet-geonames/L.Control.Geonames */ "HBiy");

__webpack_require__(/*! leaflet-range */ "TeVM");

__webpack_require__(/*! leaflet-html-legend */ "3C3U");

var _HabitatLayer = __webpack_require__(/*! ./HabitatLayer */ "O7kx");

var _HabitatLayer2 = _interopRequireDefault(_HabitatLayer);

var _utils = __webpack_require__(/*! ../../utils */ "L/hj");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* This is a workaround for a webpack-leaflet incompatibility (https://github.com/PaulLeCam/react-leaflet/issues/255)w */
delete _leaflet2.default.Icon.Default.prototype._getIconUrl;
_leaflet2.default.Icon.Default.mergeOptions({
    iconRetinaUrl: __webpack_require__(/*! leaflet/dist/images/marker-icon-2x.png */ "qXhe"),
    iconUrl: __webpack_require__(/*! leaflet/dist/images/marker-icon.png */ "TJ5S"),
    shadowUrl: __webpack_require__(/*! leaflet/dist/images/marker-shadow.png */ "wkq0")
});

var Map = function (_React$Component) {
    _inherits(Map, _React$Component);

    function Map(props) {
        _classCallCheck(this, Map);

        var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));

        _this.mapNode = null;
        _this.map = null;
        _this.mapIsMoving = false;
        _this.legendControl = null;
        _this.pointMarker = null;
        _this.previousUrls = [];
        _this.compositeLayer = null;
        _this.colorScheme = null;
        return _this;
    }

    _createClass(Map, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var lethargy = new _lethargy.Lethargy(7, 10, 0.05); // Help minimize jumpy zoom with Apple mice and trackpads
            _leaflet2.default.Map.ScrollWheelZoom.prototype._onWheelScroll = function (e) {
                _leaflet2.default.DomEvent.stop(e);

                if (lethargy.check(e) === false) {
                    return;
                }

                var delta = _leaflet2.default.DomEvent.getWheelDelta(e);
                if (delta <= -0.25) delta = -0.25;
                if (delta >= 0.25) delta = 0.25;

                this._delta += delta;
                this._lastMousePos = this._map.mouseEventToContainerPoint(e);

                this._performZoom();
            };

            this.map = _leaflet2.default.map(this.mapNode, {
                zoom: 4,
                center: [55.0, -112.0],
                minZoom: 3,
                maxZoom: 13
            });

            this.map.on('moveend', function (event) {
                _this2.mapIsMoving = false;
                setTimeout(function () {
                    if (!this.mapIsMoving) {
                        this.props.onMapMove(this.map.getCenter());
                    }
                }.bind(_this2), 1);
            });

            this.map.on('movestart', function (event) {
                _this2.mapIsMoving = true;
            });

            this.map.on('zoomend', function () {
                _this2.props.onMapZoom(_this2.map.getZoom());
            });

            this.map.zoomControl.setPosition('topright');
            this.map.addControl(_leaflet2.default.control.zoomBox({
                position: 'topright'
            }));

            var geonamesControl = _leaflet2.default.control.geonames({
                position: 'topright',
                username: 'spht',
                showMarker: false,
                showPopup: false
            });
            geonamesControl.on('select', function (_ref) {
                var geoname = _ref.geoname;

                var latlng = { lat: parseFloat(geoname.lat), lng: parseFloat(geoname.lng) };
                _this2.map.setView(latlng);
                _this2.map.fire('click', { latlng: latlng });
            });
            this.map.addControl(geonamesControl);

            var opacityControl = _leaflet2.default.control.range({
                position: 'topright',
                min: 0,
                max: 1,
                value: 0.70,
                step: .01,
                orient: 'vertical'
            });
            opacityControl.on('input change', function (e) {
                _this2.props.onSetOpacity(parseFloat(e.value));
            });
            this.map.addControl(opacityControl);

            var basemapControl = _leaflet2.default.control.basemaps({
                basemaps: [_leaflet2.default.tileLayer('//{s}.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}', {
                    attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ',
                    maxZoom: 16,
                    subdomains: ['server', 'services']
                }), _leaflet2.default.tileLayer('//{s}.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
                    attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ',
                    maxZoom: 16,
                    subdomains: ['server', 'services']
                }), _leaflet2.default.tileLayer('//{s}.arcgisonline.com/ArcGIS/rest/services/World_Terrain_Base/MapServer/tile/{z}/{y}/{x}', {
                    attribution: 'Tiles &copy; Esri &mdash; Source: USGS, Esri, TANA, DeLorme, and NPS',
                    maxZoom: 13,
                    subdomains: ['server', 'services']
                }), _leaflet2.default.tileLayer('//{s}.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
                    attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ',
                    maxZoom: 16,
                    subdomains: ['server', 'services']
                }), _leaflet2.default.tileLayer('//{s}.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
                    attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ',
                    maxZoom: 16,
                    subdomains: ['server', 'services']
                })],
                tileX: 0,
                tileY: 0,
                tileZ: 1,
                position: 'bottomleft'
            });
            this.map.addControl(basemapControl);
            this.map.on('baselayerchange', function (basemap) {
                return _this2.props.onBasemapChange(basemap);
            });

            this.legendControl = _leaflet2.default.control.htmllegend({ position: 'bottomright', disableVisibilityControls: true });
            this.legendControl.addTo(this.map);

            this.map.on('click', function (e) {
                if (!e.latlng) {
                    return;
                }

                var _e$latlng = e.latlng,
                    lng = _e$latlng.lng,
                    lat = _e$latlng.lat;

                _this2.props.onSetPoint(lng, lat);
            });
        }
    }, {
        key: 'updateMap',
        value: function updateMap(center, zoom) {
            if (this.map === null) {
                return;
            }

            var mapCenter = this.map.getCenter();
            var mapZoom = this.map.getZoom();

            if (!this.mapIsMoving && (mapCenter.lng !== center[0] || mapCenter.lat !== center[1])) {
                this.map.setView(center, zoom);
            } else if (mapZoom !== zoom) {
                this.map.setZoom(zoom);
            }
        }
    }, {
        key: 'updatePoint',
        value: function updatePoint(point) {
            var pointIsValid = point !== null && point.x && point.y;

            if (pointIsValid) {
                if (this.pointMarker === null) {
                    this.pointMarker = _leaflet2.default.marker([point.y, point.x]).addTo(this.map);
                } else {
                    this.pointMarker.setLatLng([point.y, point.x]);
                }
            } else if (this.pointMarker !== null) {
                this.map.removeLayer(this.pointMarker);
                this.pointMarker = null;
            }
        }
    }, {
        key: 'updateCompositeLayer',
        value: function updateCompositeLayer(urls, colorScheme, opacity) {
            var isUnchanged = JSON.stringify(urls) === JSON.stringify(this.previousUrls) && JSON.stringify(this.colorScheme) === JSON.stringify(colorScheme);

            if (isUnchanged) {
                return;
            }

            this.previousUrls = urls;
            this.colorScheme = colorScheme;

            if (urls.length < 1 && this.compositeLayer !== null) {
                this.map.removeLayer(this.compositeLayer);
                this.compositeLayer = null;
            } else if (urls.length > 0) {
                if (this.compositeLayer === null) {
                    this.compositeLayer = new _HabitatLayer2.default(urls, colorScheme).addTo(this.map);
                } else {
                    this.compositeLayer.setUrls(urls, colorScheme);
                }
                this.compositeLayer.setOpacity(opacity);
            }
        }
    }, {
        key: 'updateOpacity',
        value: function updateOpacity() {
            if (this.compositeLayer !== null) {
                this.compositeLayer.setOpacity(this.props.layerOpacity);
            }
        }
    }, {
        key: 'updateLegend',
        value: function updateLegend(layersToDisplay, species, distribution, _ref2) {
            var single = _ref2.single,
                kept = _ref2.kept,
                appeared = _ref2.appeared;

            if (this.legendControl === null) {
                return;
            }

            var options = this.legendControl.options;
            var legends = options.legends;


            if (!layersToDisplay.length && legends.length) {
                options.legends = [];
                this.legendControl.render();
            } else if (layersToDisplay) {
                var legend = {
                    name: _species2.default[species],
                    layer: this.compositeLayer,
                    elements: []
                };

                var layerCount = layersToDisplay.length;
                var keptColors = (0, _HabitatLayer.getColors)(kept, layerCount).map(function (color) {
                    return 'rgb(' + color.join(',') + ')';
                });
                var addedColors = (0, _HabitatLayer.getColors)(appeared, layerCount).map(function (color) {
                    return 'rgb(' + color.join(',') + ')';
                });

                if (layerCount === 1) {
                    legend.elements = [{
                        html: '<div class="legend-square" style="background-color: ' + keptColors[keptColors.length - 1] + '"></div>',
                        label: distribution.replace('_', '-')
                    }];
                } else if (layerCount > 1) {
                    var _legend$elements, _legend$elements2;

                    legend.elements[0] = {
                        html: '<div class="legend-square" style="background-color: ' + keptColors[0] + '"></div>',
                        label: 'Habitat lost'
                    };
                    (_legend$elements = legend.elements).push.apply(_legend$elements, _toConsumableArray(keptColors.slice(1).map(function (color, i) {
                        return {
                            html: '<div class="legend-square" style="background-color: ' + color + '"></div>',
                            label: 'Habitat kept (' + (i + 1) + ' scenario' + (i > 0 ? 's' : '') + ')'
                        };
                    })));
                    (_legend$elements2 = legend.elements).push.apply(_legend$elements2, _toConsumableArray(addedColors.slice(1).map(function (color, i) {
                        return {
                            html: '<div class="legend-square" style="background-color: ' + color + '"></div>',
                            label: 'Habitat gained (' + (i + 1) + ' scenario' + (i > 0 ? 's' : '') + ')'
                        };
                    })));
                }

                if (legends.length === 0) {
                    legends.push(legend);
                    this.legendControl.render();
                } else {
                    var oldLegend = legends[0];
                    var isChanged = legend.name !== oldLegend.name || JSON.stringify(legend.elements) !== JSON.stringify(oldLegend.elements);
                    if (isChanged) {
                        legends[0] = legend;
                        this.legendControl.render();
                    } else if (oldLegend.layer !== legend.layer) {
                        oldLegend.layer = legend.layer;
                        this.legendControl.render();
                    }
                }
            }
        }
    }, {
        key: 'updateState',
        value: function updateState() {
            if (this.map === null) {
                return;
            }

            var _props = this.props,
                center = _props.center,
                zoom = _props.zoom,
                point = _props.point,
                layersToDisplay = _props.layersToDisplay,
                species = _props.species,
                distribution = _props.distribution,
                colorScheme = _props.colorScheme,
                layerOpacity = _props.layerOpacity;

            this.updateMap(center, zoom);
            this.updatePoint(point);
            this.updateCompositeLayer(layersToDisplay, colorScheme, layerOpacity);
            this.updateOpacity();
            this.updateLegend(layersToDisplay, species, distribution, colorScheme);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            this.updateState();

            return _react2.default.createElement(
                'div',
                { className: 'map-container' },
                _react2.default.createElement('div', { ref: function ref(input) {
                        _this3.mapNode = input;
                    }, className: 'map-container' })
            );
        }
    }]);

    return Map;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref3) {
    var map = _ref3.map,
        configuration = _ref3.configuration,
        advanced = _ref3.advanced;
    var center = map.center,
        zoom = map.zoom,
        point = map.point;
    var species = configuration.species,
        distribution = configuration.distribution,
        model = configuration.model;
    var layerOpacity = map.layerOpacity;


    var layersToDisplay = (0, _utils.getLayerURLs)(species, distribution, model);

    return {
        center: center,
        zoom: zoom,
        point: point,
        layersToDisplay: layersToDisplay,
        layerOpacity: layerOpacity,
        species: species,
        distribution: distribution,
        colorScheme: _colors2.default[advanced.colorScheme]
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        onSetPoint: function onSetPoint(x, y) {
            dispatch((0, _map.setMapPoint)(x, y));
        },
        onSetOpacity: function onSetOpacity(opacity) {
            dispatch((0, _map.setLayerOpacity)(opacity));
        },
        onMapMove: function onMapMove(center) {
            var lat = center.lat,
                lng = center.lng;

            dispatch((0, _map.setMapCenter)([lat, lng]));
        },
        onMapZoom: function onMapZoom(zoom) {
            dispatch((0, _map.setMapZoom)(zoom));
        },
        onBasemapChange: function onBasemapChange(_ref4) {
            var _url = _ref4._url,
                options = _ref4.options;

            dispatch((0, _map.setBasemap)({ url: _url, options: options }));
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Map);

/***/ }),

/***/ "lVK7":
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(/*! react */ "GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(/*! react-dom */ "O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _App = __webpack_require__(/*! components/App */ "YCZr");

var _App2 = _interopRequireDefault(_App);

var _redux = __webpack_require__(/*! redux */ "2KeS");

var _reactRedux = __webpack_require__(/*! react-redux */ "RH2O");

var _reduxThunk = __webpack_require__(/*! redux-thunk */ "bEzl");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reducers = __webpack_require__(/*! reducers */ "ChGC");

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = (0, _redux.createStore)(_reducers2.default, (0, _redux.applyMiddleware)(_reduxThunk2.default));

_reactDom2.default.render(_react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _react2.default.createElement(_App2.default, null)
), document.getElementById('app'));

/***/ }),

/***/ "lVok":
/*!**************************************!*\
  !*** ./src/containers/ErrorModal.js ***!
  \**************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(/*! react */ "GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(/*! react-redux */ "RH2O");

var _error = __webpack_require__(/*! ../actions/error */ "9sri");

var _ModalCard = __webpack_require__(/*! ../components/ModalCard */ "3LV8");

var _ModalCard2 = _interopRequireDefault(_ModalCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ErrorModal = function (_React$Component) {
    _inherits(ErrorModal, _React$Component);

    function ErrorModal() {
        _classCallCheck(this, ErrorModal);

        return _possibleConstructorReturn(this, (ErrorModal.__proto__ || Object.getPrototypeOf(ErrorModal)).apply(this, arguments));
    }

    _createClass(ErrorModal, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                error = _props.error,
                details = _props.details,
                showModal = _props.showModal,
                _onClose = _props.onClose;


            return _react2.default.createElement(
                _ModalCard2.default,
                { open: showModal, title: 'Error', onClose: function onClose() {
                        return _onClose();
                    } },
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                        'strong',
                        null,
                        error
                    )
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    '\xA0'
                ),
                details === null ? null : _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'p',
                        null,
                        'If the problem persists, please ',
                        _react2.default.createElement(
                            'a',
                            { href: 'https://github.com/consbio/spht/issues', target: '_blank' },
                            'report an issue'
                        ),
                        ' and include the following information:'
                    ),
                    _react2.default.createElement(
                        'pre',
                        { className: 'error-debug-info' },
                        details
                    )
                )
            );
        }
    }]);

    return ErrorModal;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref) {
    var state = _ref.error;
    var error = state.error,
        details = state.details,
        showModal = state.showModal;

    return { error: error, details: details, showModal: showModal };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        onClose: function onClose() {
            return dispatch((0, _error.clearError)());
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ErrorModal);

/***/ }),

/***/ "mL1U":
/*!********************************!*\
  !*** ./src/components/Tool.js ***!
  \********************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(/*! react */ "GiK3");

var _react2 = _interopRequireDefault(_react);

var _SpeciesStep = __webpack_require__(/*! ../containers/SpeciesStep */ "Jh0i");

var _SpeciesStep2 = _interopRequireDefault(_SpeciesStep);

var _DistributionStep = __webpack_require__(/*! ../containers/DistributionStep */ "0hgf");

var _DistributionStep2 = _interopRequireDefault(_DistributionStep);

var _ModelConditionsStep = __webpack_require__(/*! ../containers/ModelConditionsStep */ "+zkC");

var _ModelConditionsStep2 = _interopRequireDefault(_ModelConditionsStep);

var _DownloadStep = __webpack_require__(/*! ../containers/DownloadStep */ "1Whh");

var _DownloadStep2 = _interopRequireDefault(_DownloadStep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tool = function Tool() {
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_SpeciesStep2.default, null),
        _react2.default.createElement(_DistributionStep2.default, null),
        _react2.default.createElement(_ModelConditionsStep2.default, null),
        _react2.default.createElement(_DownloadStep2.default, null)
    );
};

exports.default = Tool;

/***/ }),

/***/ "nVyE":
/*!*****************************!*\
  !*** ./src/reducers/map.js ***!
  \*****************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(/*! ../utils */ "L/hj");

var _map = __webpack_require__(/*! ../actions/map */ "Ytz3");

var defaultState = {
    center: [55.0, -112.0],
    zoom: 4,
    point: null,
    layerOpacity: 0.70,
    basemap: {
        url: '//{s}.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
        options: {
            attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ',
            maxZoom: 16,
            subdomains: ['server', 'services']
        }
    }
};

var map = function map() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];
    var point = state.point;

    if (point === null) {
        point = { x: null, y: null };
    }

    switch (action.type) {
        case _map.SET_MAP_CENTER:
            return (0, _utils.morph)(state, { center: action.center });

        case _map.SET_MAP_ZOOM:
            return (0, _utils.morph)(state, { zoom: action.zoom });

        case _map.SET_MAP_POINT:
            return (0, _utils.morph)(state, { point: action.point });

        case _map.SET_MAP_X:
            return (0, _utils.morph)(state, { point: (0, _utils.morph)(point, { x: action.x }) });

        case _map.SET_MAP_Y:
            return (0, _utils.morph)(state, { point: (0, _utils.morph)(point, { y: action.y }) });

        case _map.SET_LAYER_OPACITY:
            return (0, _utils.morph)(state, { layerOpacity: action.layerOpacity });

        case _map.SET_BASEMAP:
            return (0, _utils.morph)(state, { basemap: action.basemap });
    }

    return state;
};

exports.default = map;

/***/ }),

/***/ "nvBQ":
/*!****************************************!*\
  !*** ./images/nw_climate_hub_logo.png ***!
  \****************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/static/images/nw_climate_hub_logo.9a88b4ed9846987ef07cd763b4b8b51c.png";

/***/ }),

/***/ "o3wj":
/*!***********************************!*\
  !*** ./src/components/Sidebar.js ***!
  \***********************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(/*! react */ "GiK3");

var _react2 = _interopRequireDefault(_react);

var _Tool = __webpack_require__(/*! ./Tool */ "mL1U");

var _Tool2 = _interopRequireDefault(_Tool);

var _About = __webpack_require__(/*! ./About */ "w8zg");

var _About2 = _interopRequireDefault(_About);

var _Advanced = __webpack_require__(/*! ../containers/Advanced */ "wl4c");

var _Advanced2 = _interopRequireDefault(_Advanced);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var showAdvancedTab = true;

var Sidebar = function (_Component) {
    _inherits(Sidebar, _Component);

    function Sidebar(props) {
        _classCallCheck(this, Sidebar);

        var _this = _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call(this, props));

        _this.state = { activeTab: "about" };
        return _this;
    }

    _createClass(Sidebar, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var activeTab = this.state.activeTab;
            return _react2.default.createElement(
                'div',
                { className: 'sidebar-inner' },
                _react2.default.createElement(
                    'div',
                    { className: 'tabs is-boxed is-fullwidth' },
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            { className: activeTab === 'about' ? 'is-active' : null },
                            _react2.default.createElement(
                                'a',
                                { onClick: function onClick(e) {
                                        return _this2.setState({ activeTab: "about" });
                                    } },
                                'About'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: activeTab === 'tool' ? 'is-active' : activeTab === 'map' ? 'is-active-tablet' : null },
                            _react2.default.createElement(
                                'a',
                                { onClick: function onClick(e) {
                                        return _this2.setState({ activeTab: "tool" });
                                    } },
                                'Tool'
                            )
                        ),
                        showAdvancedTab ? _react2.default.createElement(
                            'li',
                            { className: activeTab === 'advanced' ? 'is-active' : null },
                            _react2.default.createElement(
                                'a',
                                { onClick: function onClick() {
                                        return _this2.setState({ activeTab: 'advanced' });
                                    } },
                                'Advanced'
                            )
                        ) : null,
                        _react2.default.createElement(
                            'li',
                            { className: (activeTab === 'map' ? 'is-active' : null) + ' is-hidden-tablet' },
                            _react2.default.createElement(
                                'a',
                                { onClick: function onClick(e) {
                                        return _this2.setState({ activeTab: "map" });
                                    } },
                                'Map'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'tab-content ' + (activeTab !== 'about' ? 'is-hidden' : '') },
                    _react2.default.createElement(_About2.default, null)
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'tab-content ' + (activeTab === 'map' ? 'is-hidden-mobile' : activeTab !== 'tool' ? 'is-hidden' : '') },
                    _react2.default.createElement(_Tool2.default, null)
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'tab-content ' + (activeTab !== 'advanced' ? 'is-hidden' : '') },
                    _react2.default.createElement(_Advanced2.default, null)
                )
            );
        }
    }]);

    return Sidebar;
}(_react.Component);

exports.default = Sidebar;

/***/ }),

/***/ "p1Rc":
/*!************************!*\
  !*** ./scss/spht.scss ***!
  \************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tDg6":
/*!*************************************!*\
  !*** ./src/containers/Map/index.js ***!
  \*************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Map = __webpack_require__(/*! ./Map */ "id1v");

var _Map2 = _interopRequireDefault(_Map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Map2.default;

/***/ }),

/***/ "uCKC":
/*!**********************************!*\
  !*** ./src/reducers/advanced.js ***!
  \**********************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(/*! ../utils */ "L/hj");

var _advanced = __webpack_require__(/*! ../actions/advanced */ "fgrL");

var defaultState = {
    colorScheme: 0
};

var advanced = function advanced() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    switch (action.type) {
        case _advanced.SET_COLOR_SCHEME:
            return (0, _utils.morph)(state, { colorScheme: action.index });
    }

    return state;
};

exports.default = advanced;

/***/ }),

/***/ "uTt8":
/*!*****************************!*\
  !*** ./images/osu_logo.png ***!
  \*****************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/static/images/osu_logo.e0fb1c5fa8be0f5f59706ed37f5c2195.png";

/***/ }),

/***/ "uwbp":
/*!*******************************!*\
  !*** ./src/actions/report.js ***!
  \*******************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createReport = exports.receiveReport = exports.fetchReport = exports.RECEIVE_REPORT = exports.FETCH_REPORT = undefined;

var _io = __webpack_require__(/*! ../io */ "ASCW");

var _utils = __webpack_require__(/*! ../utils */ "L/hj");

var _error = __webpack_require__(/*! ./error */ "9sri");

var FETCH_REPORT = exports.FETCH_REPORT = 'FETCH_REPORT';
var RECEIVE_REPORT = exports.RECEIVE_REPORT = 'RECEIVE_REPORT';

var fetchReport = exports.fetchReport = function fetchReport() {
    return {
        type: FETCH_REPORT
    };
};

var receiveReport = exports.receiveReport = function receiveReport() {
    return {
        type: RECEIVE_REPORT
    };
};

var createReport = exports.createReport = function createReport(bounds, zoom, basemap, colorScheme, species, historic, futures, opacity) {
    return function (dispatch) {
        dispatch(fetchReport());
        var inputs = {
            bounds: bounds,
            zoom: zoom,
            basemap: basemap,
            single_color: colorScheme.single,
            kept_colors: colorScheme.kept.map(function (rgb) {
                return (0, _utils.rgbToHex)(rgb);
            }),
            gained_colors: colorScheme.appeared.map(function (rgb) {
                return (0, _utils.rgbToHex)(rgb);
            }),
            species: species,
            historic: historic,
            futures: futures,
            opacity: opacity
        };

        (0, _io.executeGPTask)('create_report', inputs).then(function (json) {
            return JSON.parse(json.outputs);
        }).then(function (outputs) {
            window.location = outputs.url;
            dispatch(receiveReport());
        }).catch(function (error) {
            dispatch(receiveReport());
            dispatch((0, _error.setError)('Could not create report.', JSON.stringify(inputs, null, 2)));
            console.error(error);
        });
    };
};

/***/ }),

/***/ "w8zg":
/*!*********************************!*\
  !*** ./src/components/About.js ***!
  \*********************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(/*! react */ "GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "h4",
            { className: "title is-3" },
            "Planning for the Future"
        ),
        _react2.default.createElement(
            "p",
            null,
            "The Species Potential Habitat Tool (SPHT) is designed to help forest managers identify species or vegetation types that are suitable for specific sites given various climate change scenarios. With this information, forest managers can promote the transition of forests to species compositions that are better adapted to future climates."
        ),
        _react2.default.createElement(
            "div",
            null,
            "\xA0"
        )
    );
};

/***/ }),

/***/ "wl4c":
/*!************************************!*\
  !*** ./src/containers/Advanced.js ***!
  \************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(/*! react */ "GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(/*! react-redux */ "RH2O");

var _colors = __webpack_require__(/*! ../colors */ "Phvt");

var _colors2 = _interopRequireDefault(_colors);

var _advanced = __webpack_require__(/*! ../actions/advanced */ "fgrL");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var makeColors = function makeColors(colors) {
    return colors.map(function (color) {
        var backgroundColor = void 0;
        if (color[0] === '#') {
            backgroundColor = color;
        } else {
            var _color = _slicedToArray(color, 3),
                red = _color[0],
                green = _color[1],
                blue = _color[2];

            backgroundColor = 'rgb(' + red + ', ' + green + ', ' + blue + ')';
        }
        return _react2.default.createElement('div', {
            className: 'is-inline-block',
            style: { width: '20px', height: '20px', backgroundColor: backgroundColor },
            key: JSON.stringify(color)
        });
    });
};

var Advanced = function Advanced(_ref) {
    var colorScheme = _ref.colorScheme,
        onSelectScheme = _ref.onSelectScheme;
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'h4',
            { className: 'title is-5' },
            'Color Scheme'
        ),
        _colors2.default.map(function (scheme, i) {
            return _react2.default.createElement(
                'div',
                { style: { marginBottom: '20px' }, key: '' + i },
                _react2.default.createElement(
                    'div',
                    { className: 'is-inline-block', style: { verticalAlign: 'middle', marginRight: '10px' } },
                    _react2.default.createElement('input', { type: 'radio', checked: i === colorScheme, onChange: function onChange() {
                            return onSelectScheme(i);
                        } })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'is-inline-block', style: { verticalAlign: 'middle' } },
                    _react2.default.createElement(
                        'div',
                        null,
                        makeColors([scheme.single])
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        makeColors(scheme.kept)
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        makeColors(scheme.appeared.slice(1))
                    )
                )
            );
        })
    );
};

var mapStateToProps = function mapStateToProps(_ref2) {
    var advanced = _ref2.advanced;

    return {
        colorScheme: advanced.colorScheme
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        onSelectScheme: function onSelectScheme(index) {
            return dispatch((0, _advanced.setColorScheme)(index));
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Advanced);

/***/ })

},[0]);


// WEBPACK FOOTER //
// main.f3dced750e942fec8517.bundle.js